import { endPoints, requestType } from "../constants/variables";
import Api from "./index";

// Backend pagination (page/limit) disabled.
// Current Employee Management UI uses front-end pagination by slicing already-loaded `allWorkers`.
// If you re-enable this later, make sure callers use it on `TablePagination` events.
// export const getFilterWorkers = (page, limit) => {
//   return Api(
//     `${endPoints.fetchWorkers}?page=${page}&limit=${limit}`,
//     null,
//     requestType.GET
//   );
// };
export const getAllWorkers = (search = "") => {
  const query = search ? `?search=${encodeURIComponent(search)}` : "";
  return Api(`${endPoints.fetchWorkers}${query}`, null, requestType.GET);
};

export const getAllArchivedWorkers = () => {
  return Api(endPoints.fetchArchivedWorkers, null, requestType.GET);
};

export const createWorker = (params) => {
  return Api(endPoints.createWorker, params, requestType.POST);
};

export const updateWorkerById = (workerId, params) => {
  return Api(`${endPoints.updateWorker}/${workerId}`, params, requestType.PUT);
};

export const getWorkerDetails = (workerId, date) => {
  return Api(
    `${endPoints.workerAttendance}/${workerId}/${date}`,
    null,
    requestType.GET
  );
};

export const getAttendanceData = (workerId, startDate, endDate) => {
  return Api(
    `${endPoints.fetchAttendance}/${workerId}?startDate=${startDate}&endDate=${endDate}`,
    null,
    requestType.GET
  );
};

export const archiveWorker = (workerId) => {
  return Api(`${endPoints.archiveWorker}/${workerId}`, null, requestType.PUT);
};

export const unarchiveWorker = (workerId) => {
  return Api(`${endPoints.unarchiveWorker}/${workerId}`, null, requestType.PUT);
};
